module.exports = __webpack_public_path__ + "assets/img/index-banner4-1.8012fc30.jpg";